import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { apiGet } from "./apiClient";

export default function RequireTerms() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    (async () => {
      // First check: is there even a user logged in?
      const userId = localStorage.getItem("user");
      const token = localStorage.getItem("token");

      if (!userId || !token) {
        navigate("/", { replace: true });
        return;
      }

      try {
        // Ask the backend if this user has accepted terms
        const data = await apiGet("/users/me");

        if (!mounted) return;

        if (!data || data.terms_accepted !== true) {
          // User exists but hasn't accepted terms yet
          navigate("/consent", { replace: true });
          return;
        }

        // All good — allow access to protected routes
        setLoading(false);

      } catch (err) {
        console.error("RequireTerms error:", err);
        // Token might be expired or invalid — send back to login
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/", { replace: true });
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  if (loading) {
    return (
      <div className="auth-loading-wrapper">
        <div className="spinner" />
        <p className="auth-loading-text">در حال بررسی دسترسی…</p>
      </div>
    );
  }

  // Render the nested protected route (ChatPage or QuestionnairePage)
  return <Outlet />;
}
